// src/pages/History/RenaissanceReformation/CatholicCounterReformation.jsx
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Renaissance_&_Reformation_-_Catholic_Counter-Reformation.png';

export default function HistoryPageCatholicCounterReformation() {
  return (
    <TopicPage
      topicKey="Catholic Counter-Reformation"
      title="History: Catholic Counter-Reformation"
      backgroundImage={bg}
      startRoute="/History-Catholic-Counter-Reformation-Go"
      scrollLabels={[
        "Council of Trent",
        "Jesuit Missionaries",
        "Baroque Art and Religious Revival",
      ]}
      backRoute="/history-renaissance"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}
